module.exports = __webpack_public_path__ + "static/media/minus.b4ad41e7.svg";